import React, { useEffect, useState } from "react";

import {
  Container,
  Row
} from "react-bootstrap";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import "../css/home.css";
import { getcmsAction, getNewCmsAction } from "../../../Action/user.action";

const PrivacyPolicy = () => {
  const [termsandconditionlist, settermsandconditionlist] = useState({
    PrivacyPolicy: ""
  });
  useEffect(() => {
    getTermsAndConditionFunc();
    // setcondition();
  }, []);

  const getTermsAndConditionFunc = async () => {
    let res = await getNewCmsAction("privacypolicy");
    if (res.success && res.data?.cms_value) {
      settermsandconditionlist({ PrivacyPolicy: res.data.cms_value });
    } else {
      console.error("Failed to fetch CMS content");
    }
  };

  return (
    <>
      <div className="lighttheme bg-white overflow-hidden hero" style={{ minHeight: "100vh" }}>
        <section className="herobanner position-relative text-white overflow-hidden" style={{backgroundColor:"black"}}>
          <Container>
            <Row className="align-items-center">
              <div className="jovitClass"
                 dangerouslySetInnerHTML={{
                  __html: termsandconditionlist.PrivacyPolicy,
                }}
              />
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};
export default PrivacyPolicy;
